import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  category: "",
  description: "",
  rules: "",
  privacy: "PUBLIC",
  tags: [],
  media: [],
};

export const createCommunitySlice = () => {
  const communityDataSlice = createSlice({
    name: "communityData",
    initialState,
    reducers: {
      setCommunityData: (state, action) => {
        return { ...state, ...action.payload };
      },
      resetCommunityData: () => initialState,
    },
  });

  return communityDataSlice;
};

// Export actions for use in components
const communitySlice = createCommunitySlice();
export const { setCommunityData, resetCommunityData } = communitySlice.actions;
